import { axios } from '../../plugins/axios-pol'
import moment from 'moment'

export default {
  namespaced: true,

  state: {
    asistencias: [],
    asistenciaActual: null,
    tiposAsistencia: [],
  },

  getters: {
    getAsistencias: (state) => {
      return state.asistencias
    },
    getAsistenciaActual: (state) => {
      return state.asistenciaActual
    },
    getTiposAsistencia: (state) => {
      return state.tiposAsistencia
    },
  },

  mutations: {
    SET_ASISTENCIAS(state, asistencias) {
      state.asistencias = asistencias
    },
    SET_ASISTENCIA_ACTUAL(state, asistencia) {
      state.asistenciaActual = asistencia
    },
    SET_TIPO_ASISTENCIA(state, tipos) {
      state.tiposAsistencia = tipos
    },
  },

  actions: {
    fetchAsistencias: async function ({ commit }, idPersonal) {
      await axios
        .get('/personal/api/EstadoFuerza/personal/' + idPersonal + '/asistencia')
        .then((response) => {
          commit('SET_ASISTENCIAS', response.data.data)
        })
        .catch((error) => console.log(error))
    },

    fetchAsistenciaById: async function ({ commit }, { idPersonal, idAsistencia }) {
      await axios
        .get('/personal/api/EstadoFuerza/personal/' + idPersonal + '/asistencia/' + idAsistencia)
        .then((response) => {
          commit('SET_ASISTENCIA_ACTUAL', response.data.data)
        })
        .catch((error) => console.log(error))
    },

    fetchTipoAsistencia: async function ({ commit }) {
      await axios
        .get('/personal/api/EstadoFuerza/tipoAsistencia')
        .then((response) => {
          commit('SET_TIPO_ASISTENCIA', response.data.data)
        })
        .catch((error) => console.log(error))
    },

    verificarAsistenciaHoy: async function ({ commit }, idPersonal) {
      try {
        const response = await axios.get('/personal/api/EstadoFuerza/personal/' + idPersonal + '/asistencia')
        const asistencias = response.data.data

        const hoy = moment().format('DD/MM/YYYY')

        const asistenciaHoy = asistencias.find((asistencia) => {
          let fechaAsistencia = asistencia.fecha

          if (typeof fechaAsistencia === 'string' && fechaAsistencia.includes(' ')) {
            fechaAsistencia = fechaAsistencia.split(' ')[0]
          }

          return fechaAsistencia === hoy
        })

        return !!asistenciaHoy
      } catch (error) {
        console.log(error)
        return false
      }
    },

    saveAsistencia: async function ({ commit }, { idPersonal, asistencia }) {
      await axios
        .post('/personal/api/EstadoFuerza/personal/' + idPersonal + '/asistencia', asistencia)
        .then((response) => {
          commit('SET_SNACKBAR_MESSAGE', 'Asistencia guardada correctamente.', { root: true })
        })
        .catch((error) => {
          commit('SET_SNACKBAR_MESSAGE', 'Error al guardar la asistencia.', { root: true })
          console.log(error)
        })
    },
  },
}
